import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconUsers = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 107.02702 91.936111">
    <path fill={theme.palette.primary.A400} d="m99.367 7.6782h-7.0706l7.6596 17.042h7.0706v-9.4025c0-4.2004-3.4456-7.6394-7.6596-7.6394" />
    <path fill={theme.palette.primary.A100} d="m99.942 15.318v9.4025h-51.09v-17.042h43.455c4.2 0 7.6342 3.439 7.6342 7.6394" />
    <path fill={theme.palette.primary.A100} transform="translate(92.297 17.229)" d="m0.014614 0.034113-22.078 74.688h32.793c2.2091 0 4-1.7909 4-4v-63.018c0-4.2174-3.4446-7.6703-7.6519-7.6703h-7.0636z" />
    <path fill={theme.palette.grey[100]} d="m53.492 17.152v-9.4546c0-4.2239-3.44-7.6817-7.6417-7.6817h-31.156-7.0535c-4.2023-0.000178-7.64 3.4577-7.64 7.6815v80.254c0 2.2091 1.7909 4 4 4h91.931c2.2091 0 4-1.7909 4-4v-63.118c0-4.2237-3.4401-7.6817-7.6419-7.6817h-38.797z" />
    <path fill={theme.palette.primary.A400} d="m90.246 71.351h-4.6724l-8.1932-12.922c7.0202 0 12.866 5.7853 12.866 12.922" />
    <path fill={theme.palette.primary.A100} d="m77.502 58.43c-7.0855 0-12.987 5.7854-12.987 12.922h21.256c-0.000447-7.1365-3.7589-12.922-8.2692-12.922" />
    <path fill={theme.palette.primary.A400} d="m77.194 37.08v14.233c3.9132 0 7.0854-3.1867 7.0854-7.1152 0-3.931-3.1724-7.1177-7.0854-7.1177" />
    <path fill={theme.palette.primary.A400} d="m42.512 71.351h-4.6725l-8.1931-12.922c7.0205 0 12.866 5.7853 12.866 12.922" />
    <path fill={theme.palette.primary.A100} d="m29.582 58.43c-7.0855 0-12.987 5.7854-12.987 12.922h21.256c0.000179-7.1365-3.7583-12.922-8.2692-12.922" />
    <path fill={theme.palette.primary.A400} d="m29.46 37.08v14.233c3.9132 0 7.0854-3.1867 7.0854-7.1152-0.000179-3.931-3.1726-7.1177-7.0854-7.1177" />
    <path fill={theme.palette.primary.A400} d="m53.514 58.991 10.307 17.416h7.0338c0-9.6197-7.7626-17.416-17.341-17.416" />
    <path fill={theme.palette.primary.A100} d="m53.598 58.991c-9.6249 0.000446-17.425 7.7972-17.425 17.416h27.782c0-9.6197-4.6364-17.416-10.357-17.416" />
    <path fill={theme.palette.primary.A400} d="m53.7 32.586v19.289c5.2635-0.06624 9.5094-4.359 9.5094-9.6446s-4.2459-9.5785-9.5094-9.6446" />
    <g fill={theme.palette.primary.A100}>
      <path d="m53.764 32.588c-0.0426-0.0023-0.08493-0.0023-0.12752-0.0023-0.0426 0-0.08493 0-0.12752 0.0023-5.2608 0.06613-9.5046 4.358-9.5046 9.6423s4.2436 9.5761 9.5046 9.6423c0.0426 0.0023 0.08493 0.0023 0.12752 0.0023 0.0426 0 0.08493 0 0.12752-0.0023 2.6529-0.13235 4.7841-4.3981 4.7841-9.6423s-2.1312-9.5099-4.7841-9.6423" />
      <path d="m29.505 37.08c1.3134 0 2.3797 3.1867 2.3797 7.1177 0 3.9288-1.0663 7.1152-2.3797 7.1152-3.9377 0-7.1297-3.1867-7.1297-7.1152 0.00018-3.931 3.192-7.1177 7.1297-7.1177" />
      <path d="m77.238 37.08c1.3134 0 2.3797 3.1867 2.3797 7.1177 0 3.9288-1.0663 7.1152-2.3797 7.1152-3.9377 0-7.1297-3.1867-7.1297-7.1152-0.00027-3.931 3.1918-7.1177 7.1297-7.1177" />
    </g>
  </SvgIcon>
);

IconUsers.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        A100: PropTypes.string.isRequired,
        A400: PropTypes.string.isRequired,
      }).isRequired,
      grey: PropTypes.shape({
        100: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconUsers);



// WEBPACK FOOTER //
// ./src/components/icons/IconUsers.js